import React, { useState } from 'react'
import { renderToString } from 'react-dom/server'
import Link from 'gatsby-link'
import { resolvePath } from '../utils/helpers.js'
import Showdown from 'showdown'
import { graphql, navigate } from 'gatsby'
import Layout from '../components/layout'
import Hero from '../components/heroSubpage'
import SEO from '../components/seo'
import CardRelated from '../components/cardRelated'
import Card from '../components/card'
import Cta from '../components/cta'
import CarouselQuote from '../components/carouselQuote'
import Requirements from '../components/requirements'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { MDBRow, MDBCol, MDBContainer, MDBAnimation } from 'mdbreact'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fat } from '@fortawesome/pro-thin-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'

library.add(fat, fab)

const ProductTemplate = ({ data, location }) => {
  const post = data.markdownRemark
  const heroImage = data.heroImage
  const converter = new Showdown.Converter()

  const bodyDiv = '<div class="richtext product divlink">'
  const openingPara = `${post.frontmatter.openingpara ? renderToString(<div className="font-w-400 text-xs-extra-large divlink text-opening-para" dangerouslySetInnerHTML={{ __html: converter.makeHtml(post.frontmatter.openingpara), }} />) : ''}` 
  const openInSection = `<div data-test="container" class="container"><div data-test="row" class="row"><div data-test="col" class="col-lg-12">`
  const closeInSection = '</div></div></div></div>'
  const backButton = `${!post.frontmatter.section.length > 0 ? renderToString(<div><div data-test="container" class="container"><p className="pt-lg-4 mt-md-4 text-large"><a href={location.pathname.substring(0, location.pathname.indexOf("/", 11)+1)} className="nav-link btn btn-mdb-color" onClick={() => navigate(-1)}><FontAwesomeIcon icon={faArrowLeft} className="mr-1" />&nbsp;&nbsp;Back to {location.pathname.substring(10, location.pathname.indexOf("/", 11)).replace(/[^a-z0-9]/gi, " ")}</a></p></div></div>) : ''}`

  const InjectTags = (quote, index) => {
    return `${closeInSection}</div>${renderToString(<CarouselQuote data={quote.slice(index, index+1)} maintag="div" />)}<div class="bg-white">${openInSection}${bodyDiv}`; 
  }

  const InjectCarousel = (body, quote) => {
    return `${body
      .replace("<Quote1 />", InjectTags(quote, 0))
      .replace("<Quote2 />", InjectTags(quote, 1))
      .replace("<Quote3 />", InjectTags(quote, 2))
      .replace("<Quote4 />", InjectTags(quote, 3))
      .replace("<Quote5 />", InjectTags(quote, 4))
    }`; 
  }

  // const alteredbody = post.html.indexOf("<Quote") !== -1 ? `<div data-test="container" class="container"><div data-test="row" class="row"><div data-test="col" class="col-lg-12"><div class="richtext product divlink">${InjectCarousel(post.html, post.frontmatter.quote)}</div></div></div></div>` : null
  const alteredbody = post.html.indexOf("<Quote") !== -1 ? `${openInSection}${openingPara}${bodyDiv}${InjectCarousel(post.html, post.frontmatter.quote)}${closeInSection}${backButton}` : null

  const btnId = (location.state != null && location.state.btn != null) ? location.state.btn : post.frontmatter.requirements ? post.frontmatter.requirements[0].subtitle : ""

  return (
    <div id="sub-page">
      <Layout>
        <Hero
          class="intro-65"
          image={heroImage?.childImageSharp?.gatsbyImageData}
          foreimage={null}
          title={post.frontmatter.title}
          subtitle={post.frontmatter.subtitle}
          ctatext={post.frontmatter.ctatext}
          ctaslug={post.frontmatter.ctaslug}     
          type="root"
        />

        {!alteredbody ?
        <section className="bg-white">
          <MDBContainer>
            <MDBRow>
              <MDBCol lg={ post.frontmatter.headline && post.frontmatter.headline.length >= 1 ? '8' : '12' } >
                {post.frontmatter.openingpara &&
                  <div
                    className="font-w-400 text-xs-extra-large divlink text-opening-para"
                    dangerouslySetInnerHTML={{ __html: converter.makeHtml(post.frontmatter.openingpara), }}
                  />
                }

                <div
                  className="richtext product divlink"
                  dangerouslySetInnerHTML={{ __html: post.html }}
                />

                {!post.frontmatter.section.length > 0 &&
                  <div>
                    <p className="pt-lg-4 mt-md-4 text-large">
                      <a href={location.pathname.substring(0, location.pathname.indexOf("/", 11)+1)} className="nav-link btn btn-mdb-color" onClick={() => navigate(-1)}><FontAwesomeIcon icon={faArrowLeft} className="mr-1" />&nbsp;&nbsp;Back to {location.pathname.substring(10, location.pathname.indexOf("/", 11)).replace(/[^a-z0-9]/gi, " ")}</a>
                    </p>
                  </div>
                }
              </MDBCol>

              {post.frontmatter.headline &&
                post.frontmatter.headline.length >= 1 && (
                  <MDBCol lg="4" md="12" className="pl-lg-5">
                    {post.frontmatter.headline.map((headlines, index) => (
                      <div className="headline-tile mt-lg-3 item-headline" key={index} >
                        <div className="headline-icon">
                          <FontAwesomeIcon icon={['fat', headlines.icon]} size="2x" className="fa-fw" />
                        </div>
                        <div className="headline-content">
                          <h3 className="font-alt font-w-700 letter-spacing-1 text-xs-medium text-medium">
                            {headlines.title}
                          </h3>
                          <div className="headline-action font-alt letter-spacing-1 text-xs-medium text-small">
                            {headlines.resource ? (
                              <a href={headlines.resource.publicURL} className="effect-noline" target="_blank" rel="noopener" >
                                {headlines.linktext}
                                <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
                              </a>
                            ) : headlines.link.substring(0,4) == 'http' ? (
                              <a href={headlines.link} className="effect-noline" target="_blank" rel="noopener" >
                                {headlines.linktext}
                                <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
                              </a>
                            ) : (
                              <Link to={resolvePath(headlines.link)} className="effect-noline" >
                                {headlines.linktext}
                                <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
                              </Link>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </MDBCol>
                )}
            </MDBRow>
          </MDBContainer>
        </section>
        : 
        <section
          className="bg-white"
          dangerouslySetInnerHTML={{ __html: alteredbody, }}
        />
        }

        {post.frontmatter.section.map((sections, index) => (
          <section className="bg-light-blue-prods" key={index}>
            <MDBContainer>
              <MDBRow>
                <MDBCol md="4" className="pr-5">
                  <div className="section-intro pb-5">
                    <h2 className="font-alt font-w-700 letter-spacing-1 title-xs-medium title-large">
                      {sections.title}
                    </h2>
                    <p className="text-medium text-gray-dark mt-3">
                      {sections.description}
                    </p>

                    {sections.link &&
                      <p>
                        <Link to={resolvePath(sections.link)} className="text-medium-small effect">{sections.linktext}</Link>
                      </p>
                    }
                  </div>
                </MDBCol>

                <MDBCol md="8">
                  <MDBRow>
                    {sections.feature.map((features, indx) => (
                      <MDBCol md="6" className="pb-5 item-prods" key={indx}>
                        <div className="feature-icon">
                          <FontAwesomeIcon icon={['fat', features.icon]} size="3x" />
                          <FontAwesomeIcon icon={['fab', features.icon]} size="3x" />
                        </div>
                        <p className="text-medium text-blue-dark font-w-700">
                          {features.title}
                        </p>
                        {/* <p className="text-medium text-gray-dark">
                          {features.description}
                        </p> */}
                        <div
                          className="text-medium text-gray-dark"
                          dangerouslySetInnerHTML={{ __html: features.description, }}
                        />
                        {features.link !== null && (
                          <p className="text-small">
                            <Link to={resolvePath(features.link)} className="effect">
                              {features.linktext}
                            </Link>
                          </p>
                        )}
                      </MDBCol>
                    ))}
                  </MDBRow>
                </MDBCol>
              </MDBRow>
            </MDBContainer>
          </section>
        ))}

        {post.frontmatter.requirements && post.frontmatter.requirements.length >= 1  && (
          <Requirements data={post.frontmatter.requirements} btnId={btnId} bgIndex={post.frontmatter.section.length} /> 
        )}

        {(post.frontmatter.quote && !alteredbody) && (
          <CarouselQuote data={post.frontmatter.quote} />
        )}

        {post.frontmatter.related && post.frontmatter.related.length >= 1 && (
          <section className="bg-gray-light">
            <MDBContainer>
              <MDBRow>
                <MDBCol md="12" className="mb-5">
                  <h3 className="font-alt font-w-700 letter-spacing-1 title-xs-medium title-medium">
                    Related products, solutions and news
                  </h3>
                </MDBCol>
              </MDBRow>

              <MDBRow>
                {post.frontmatter.related.map((relate, index) => {
                  return (
                    <CardRelated
                      key={index}
                      collg="4"
                      colmd="6"
                      height="9rem"
                      type={relate.type}
                      title={relate.title}
                      suite={post.frontmatter.suite}
                      description={relate.description}
                      linktext={relate.linktext}
                      link={relate.link}
                    />
                  )
                })}
              </MDBRow>
            </MDBContainer>
          </section>
        )}

        {post.frontmatter.helpfulresources && (
          <section className="bg-white-grey-gradient">
            <MDBAnimation reveal type="fadeIn" duration="1587ms">
              <MDBContainer>
                <h2 className="font-alt font-w-700 letter-spacing-1 title-xs-large title-large text-left pb-5">
                  {post.frontmatter.helpfulresources.title}
                  <span id="helpful-resources" className="anchor">
                    &nbsp;
                  </span>
                </h2>

                {post.frontmatter.helpfulresources.subtitle && (
                  <p className="text-medium">
                    {post.frontmatter.helpfulresources.subtitle}
                  </p>
                )}

                {post.frontmatter.helpfulresources.helpfulres && (
                  <MDBRow className="pt-3">
                    {post.frontmatter.helpfulresources.helpfulres.map(
                      (helpfulres, index) => (
                        <Card
                          key={index}
                          collg="4"
                          colmd="6"
                          height="10rem"
                          title={helpfulres.title}
                          subtitle={helpfulres.subtitle}
                          description={helpfulres.description}
                          image={ helpfulres.image.childImageSharp.gatsbyImageData }
                          alt={helpfulres.alttext}
                          placement={helpfulres.placement}
                          link={ helpfulres.link ? helpfulres.link : helpfulres.document.publicURL }
                          titleclass="title-small"
                          descriptionClass="text-card-small py-2"
                        />
                      )
                    )}
                  </MDBRow>
                )}
              </MDBContainer>
            </MDBAnimation>
          </section>
        )}

        {post.frontmatter.cta && (
          <Cta
            ctatitle={post.frontmatter.cta.title}
            ctadescription={post.frontmatter.cta.description}
            ctalink={post.frontmatter.cta.link}
            ctalinktext={post.frontmatter.cta.linktext}
          />
        )}
      </Layout>
    </div>
  )
}
export default ProductTemplate

export function Head({ data, location }) {
  const heroImage = data.heroImage
  const post = data.markdownRemark
  return (
    <SEO
      title={post.frontmatter.meta.title}
      description={post.frontmatter.meta.title}
      url={location.pathname} 
      image={heroImage.childImageSharp?.gatsbyImageData?.images?.fallback?.src}
      canonical={location.pathname}                  
    />
  )
}

export const query = graphql`
  query ($slug: String!) {
    markdownRemark(
      fields: { slug: { eq: $slug } }
      frontmatter: { template: { eq: "products" } }
    ) {
      html
      frontmatter {
        meta {
          title
          description
        }
        template
        title
        subtitle
        ctatext
        ctaslug     
        openingpara
        suite
        section {
          title
          description
          linktext
          link
          feature {
            title
            icon
            description
            linktext
            link
          }
        }
        quote {
          strapline
          author
        }        
        related {
          type
          title
          description
          linktext
          link
        }
        helpfulresources {
          title
          subtitle
          helpfulres {
            title
            subtitle
            description
            placement
            link
            alttext
            image {
              childImageSharp {
                gatsbyImageData(quality: 90)
              }
            }
            document {
              publicURL
            }
          }
        }
        requirements {
          title
          subtitle
          description
        }
        cta {
          title
          description
          linktext
          link
        }
      }
    }
    heroImage: file(name: { eq: "product-banner" }) {
      childImageSharp {
        gatsbyImageData(quality: 90)
      }
    }
  }
`
